(function ($) {
  function resizeCards() {
    let equalHeightCardGrids = $(".card-grid.equal-height");

    if (equalHeightCardGrids.length == 0) return;

    equalHeightCardGrids.each(function (index) {
      var $grid = $(this);
      let cards = $grid.find(".card");
      if (cards.length == 0) return;

      let cardWidth = cards.first().outerWidth();

      $grid.css("--min-card-height", cardWidth / 16 + "rem");
    });
  }

  $(document).ready(function () {
    resizeCards();
  });

  jfDebounce("resize", resizeCards, 100);
})(jQuery);
